import { FunctionComponent } from 'react'
import CustomizedFieldList from '@/components/kol/common/kol-cooperation-detail-drawer/custom/customized-field-list'
import { ConfigureCollaborationNotesProperties } from '@/utils/ampli'

interface CustomProps {
  kolId: string
  from?: ConfigureCollaborationNotesProperties['from']
}

const Custom: FunctionComponent<CustomProps> = ({ kolId, from }) => {
  return <CustomizedFieldList from={from} kolId={kolId} />
}

export default Custom
